<div class="financeiro-page">
  <div class="header d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div>
      <h1>Configuração API — Santander</h1>
      <p class="text-muted small mb-0">
        Credenciais do Portal do Desenvolvedor, certificado digital e workspace para emissão de boletos via API.
        Configuração vinculada à <strong>empresa ID 1</strong> (cedente Santander).
      </p>
    </div>
    <div class="d-flex flex-wrap gap-2">
      <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="carregando" (click)="carregarConfig()">
        <i class="fa fa-refresh"></i> Recarregar
      </button>
      <a routerLink="/gerar-boleto" class="btn btn-outline-secondary btn-sm">Gerar boleto</a>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Dados da conta (cobrança)</h2>
    <div class="row g-2 form-grid">
      <div class="col-md-6">
        <label class="form-label">Nome do banco</label>
        <input type="text" class="form-control form-control-sm" maxlength="100" [(ngModel)]="configForm.descricao" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Convênio (7 dígitos) *</label>
        <input type="text" class="form-control form-control-sm" maxlength="10" [(ngModel)]="configForm.codigoConvenio" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Agência *</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="configForm.agencia" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Dígito agência *</label>
        <input type="text" class="form-control form-control-sm" maxlength="2" [(ngModel)]="configForm.digitoAgencia" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Conta *</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="configForm.contaCorrente" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Dígito conta *</label>
        <input type="text" class="form-control form-control-sm" maxlength="2" [(ngModel)]="configForm.digitoConta" />
      </div>
      <div class="col-md-8">
        <label class="form-label">Nome beneficiário (cobrança)</label>
        <input type="text" class="form-control form-control-sm" maxlength="60" [(ngModel)]="configForm.nomeBeneficiarioCobranca" />
      </div>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Encargos padrão (multa e juros)</h2>
    <p class="text-muted small mb-3">
      Percentuais enviados à API Santander no registro do boleto (<code>finePercentage</code> e
      <code>interestPercentage</code>). Máximo 60% cada. Se o título tiver multa/juros próprios no financeiro,
      esses valores têm prioridade.
    </p>
    <div class="row g-2 form-grid">
      <div class="col-md-3">
        <label class="form-label">Multa (%)</label>
        <input
          type="number"
          class="form-control form-control-sm"
          min="0"
          max="60"
          step="0.01"
          [(ngModel)]="configForm.apiMultaPercentual"
          placeholder="Ex.: 2.00"
        />
        <small class="text-muted">% sobre o valor do título</small>
      </div>
      <div class="col-md-3">
        <label class="form-label">Juros mensal (%)</label>
        <input
          type="number"
          class="form-control form-control-sm"
          min="0"
          max="60"
          step="0.01"
          [(ngModel)]="configForm.apiJurosPercentualMensal"
          placeholder="Ex.: 10.00"
        />
        <small class="text-muted">% ao mês por atraso</small>
      </div>
      <div class="col-md-3">
        <label class="form-label">Dias após venc. (multa)</label>
        <input
          type="number"
          class="form-control form-control-sm"
          min="0"
          max="99"
          step="1"
          [(ngModel)]="configForm.apiMultaDiasAposVencimento"
          placeholder="0"
        />
        <small class="text-muted">0 = no vencimento</small>
      </div>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Credenciais da aplicação (Portal do Desenvolvedor)</h2>
    <div class="row g-2 form-grid">
      <div class="col-md-3">
        <label class="form-label">Ambiente</label>
        <select class="form-control form-control-sm" [(ngModel)]="configForm.apiAmbiente">
          <option value="S">Sandbox (homologação)</option>
          <option value="P">Produção</option>
        </select>
      </div>
      <div class="col-md-5">
        <label class="form-label">Client ID *</label>
        <input
          #clientIdInput
          type="text"
          class="form-control form-control-sm"
          name="santanderApiClientId"
          [(ngModel)]="apiClientId"
          (input)="apiClientId = clientIdInput.value"
          autocomplete="off"
        />
      </div>
      <div class="col-md-4">
        <label class="form-label">Client Secret *</label>
        <input
          #clientSecretInput
          type="password"
          class="form-control form-control-sm"
          name="santanderApiClientSecret"
          [(ngModel)]="apiClientSecret"
          (input)="apiClientSecret = clientSecretInput.value"
          [placeholder]="clientSecretConfigurado ? 'Deixe em branco para manter o atual' : ''"
          autocomplete="new-password"
        />
      </div>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Certificado digital (.pfx)</h2>
    <div class="row g-2 align-items-end">
      <div class="col-md-5">
        <label class="form-label">Arquivo .pfx / .p12</label>
        <input type="file" class="form-control form-control-sm" accept=".pfx,.p12"
          (change)="onCertificadoSelecionado($event)" />
        <small class="text-muted" *ngIf="certificadoConfigurado">
          Certificado atual: <strong>{{ certificadoArquivo }}</strong>
        </small>
      </div>
      <div class="col-md-3">
        <label class="form-label">Senha do certificado</label>
        <input type="password" class="form-control form-control-sm" [(ngModel)]="certificadoSenha" autocomplete="new-password" />
      </div>
      <div class="col-md-4">
        <button type="button" class="btn btn-outline-secondary btn-sm w-100" [disabled]="enviandoCertificado || !arquivoCertificado"
          (click)="enviarCertificado()">
          Enviar certificado
        </button>
      </div>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Workspace (API de cobrança)</h2>
    <p class="text-muted small">
      A workspace vincula o convênio à API. Crie uma vez após salvar credenciais e certificado.
    </p>
    <div class="row g-2 align-items-center">
      <div class="col-md-8">
        <label class="form-label">Workspace ID</label>
        <input type="text" class="form-control form-control-sm" [value]="workspaceId" readonly
          placeholder="Ainda não criada" />
      </div>
      <div class="col-md-4 d-flex flex-wrap gap-2">
        <button type="button" class="btn btn-outline-primary btn-sm flex-fill" [disabled]="testandoConexao"
          (click)="testarConexao()">
          Testar conexão
        </button>
        <button type="button" class="btn btn-primary btn-sm flex-fill" [disabled]="criandoWorkspace || !!workspaceId"
          (click)="criarWorkspace()">
          Criar workspace
        </button>
      </div>
    </div>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Webhook — liquidação automática</h2>
    <p class="text-muted small">
      O Santander envia notificações de pagamento para esta URL. Em produção use HTTPS público.
      Complemente com a consulta manual na tela Gerar Boleto.
    </p>
    <div class="row g-2 align-items-end">
      <div class="col-md-8">
        <label class="form-label">URL do webhook</label>
        <input type="url" class="form-control form-control-sm" [(ngModel)]="configForm.webhookUrl"
          placeholder="https://sua-api.com/api/financeiro/SantanderWebhook/1" />
        <small class="text-muted" *ngIf="webhookUrlSugerida">
          Sugestão (esta API): <a href="#" (click)="$event.preventDefault(); usarUrlWebhookSugerida()">{{ webhookUrlSugerida }}</a>
        </small>
      </div>
      <div class="col-md-2">
        <label class="form-check-label small d-block mb-1">
          <input type="checkbox" class="form-check-input me-1" [(ngModel)]="configForm.webhookBoletoAtivo" />
          Boleto (código de barras)
        </label>
        <label class="form-check-label small d-block">
          <input type="checkbox" class="form-check-input me-1" [(ngModel)]="configForm.webhookPixAtivo" />
          PIX (BolePix)
        </label>
      </div>
      <div class="col-md-2">
        <button type="button" class="btn btn-outline-primary btn-sm w-100"
          [disabled]="configurandoWebhook || !workspaceId" (click)="configurarWebhook()">
          Ativar no Santander
        </button>
      </div>
    </div>
  </div>

  <div class="card-box mb-3" *ngIf="webhookLogs.length || carregandoWebhookLogs">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h2 class="h6 mb-0">Log de webhooks (recentes)</h2>
      <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="carregandoWebhookLogs"
        (click)="carregarWebhookLogs()">
        <i class="fa fa-refresh"></i> Atualizar
      </button>
    </div>
    <p class="text-muted small" *ngIf="carregandoWebhookLogs">Carregando...</p>
    <div class="table-responsive" *ngIf="!carregandoWebhookLogs && webhookLogs.length">
      <table class="table table-sm table-striped mb-0">
        <thead>
          <tr>
            <th>Data</th>
            <th>Função</th>
            <th>Conta</th>
            <th>Resultado</th>
            <th>Mensagem</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of webhookLogs">
            <td>{{ log.dataHora | date:'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ log.funcao || '-' }}</td>
            <td>{{ log.idContaReceber || '-' }}</td>
            <td>
              <span *ngIf="log.liquidacaoAplicada">Baixado</span>
              <span *ngIf="log.estornoAplicado">Estorno</span>
              <span *ngIf="!log.liquidacaoAplicada && !log.estornoAplicado">{{ log.processado ? 'Processado' : 'Ignorado' }}</span>
            </td>
            <td>{{ log.mensagem || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="d-flex justify-content-end">
    <button type="button" class="btn btn-primary" [disabled]="salvandoConfig" (click)="salvarConfiguracao()">
      Salvar configuração
    </button>
  </div>
</div>
